import { render } from "./PopoverMenu.vue?vue&type=template&id=52d91350&scoped=true&ts=true"
import script from "./PopoverMenu.vue?vue&type=script&lang=ts"
export * from "./PopoverMenu.vue?vue&type=script&lang=ts"

import "./PopoverMenu.vue?vue&type=style&index=0&id=52d91350&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d91350"]])

export default __exports__